var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popover-explain" },
    [
      _c("div", [
        _c("div", { staticClass: "text-black" }, [
          _vm._v(" " + _vm._s(_vm.$t("Search.explanation.example")) + ": "),
        ]),
        _c("img", {
          staticClass: "popover-explain__img mb-3",
          attrs: { src: _vm.imgSrc },
        }),
      ]),
      _vm._l(_vm.fields, function (field, index) {
        return _c("div", { key: index, staticClass: "popover-explain--row" }, [
          _c("span", { staticClass: "mr-1" }, [
            _vm._v(_vm._s(field.field) + "="),
          ]),
          _c("span", { staticClass: "popover-explain__vertical" }, [
            _c("span", { staticClass: " px-1" }, [
              _vm._v(_vm._s(field.molecule)),
            ]),
            _c("span", { staticClass: "popover-explain__vertica--line" }),
            _c("span", { staticClass: "px-1" }, [
              _vm._v(_vm._s(field.denominator)),
            ]),
          ]),
          _c("span", { staticClass: "mx-1" }, [_vm._v(" = ")]),
          _c("span", { staticClass: "popover-explain__vertical" }, [
            _c("span", { staticClass: "px-1" }, [
              _vm._v(_vm._s(field.moleculeValue)),
            ]),
            _c("span", { staticClass: "popover-explain__vertica--line" }),
            _c("span", { staticClass: "px-1" }, [
              _vm._v(_vm._s(field.denominatorValue)),
            ]),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }